import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams, useLocation, useSearchParams } from 'react-router-dom';
import { Row, Col, Spinner, Button, Tooltip, Modal } from 'reactstrap';
import { Accordion, Card, ProgressBar, Spinner as BootstrapSpinner } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import { useForm, useFieldArray } from 'react-hook-form';
import CryptoJS from 'crypto-js';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import 'bootstrap-icons/font/bootstrap-icons.css';
import axios from 'axios';

// Utility-Service
import { getToken, getUser } from '../../utility/AuthService';

// API-Service
import { userAnswerService } from '../../../src/services/userQ&AService';
import { sectionQuestionService } from '../../../src/services/sectionService';
import { getAssociatedCompaniesSubmissionService } from '../../services/associatedCompamiesSubmissionDetalisService';
import { indicatorListService } from '../../../src/services/indicatorService';
import { dimensionListService } from '../../../src/services/dimensionService';

//redux
import { selectLanguageUse } from '../../redux/slices/language.Slice';

const StyledQuestionPage = styled.div`
  padding: 1rem;
  
  .section-card {
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    margin-bottom: 1.5rem;
    transition: transform 0.2s ease;
    
    &:hover {
      transform: translateY(-2px);
    }
  }
  
  .question-header {
    background: linear-gradient(135deg, #1e3250 0%, #2c4a74 100%);
    color: white;
    padding: 1rem;
    border-radius: 12px 12px 0 0;
    font-size: 1.1rem;
    font-weight: 500;
  }
  
  .question-body {
    padding: 1.5rem;
  }
  
  .form-control {
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    padding: 0.75rem;
    transition: border-color 0.2s ease;
    
    &:focus {
      border-color: #1e3250;
      box-shadow: 0 0 0 2px rgba(30, 50, 80, 0.2);
    }
  }
  
  .btn-primary {
    background: #1e3250;
    border: none;
    border-radius: 8px;
    padding: 0.75rem 1.5rem;
    font-weight: 500;
    transition: background-color 0.2s ease;
    
    &:hover {
      background: #2c4a74;
    }
  }
  
  .progress-section {
    background: white;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    margin-bottom: 2rem;

    .progress-overview {
        h4 {
            color: #495057;
            margin-bottom: 1rem;
            font-weight: 600;
        }

        .progress-bar-container {
            margin-bottom: 1rem;

            .progress {
                height: 1.5rem;
                background-color: #e9ecef;
                border-radius: 0.5rem;
                overflow: hidden;

                .progress-bar {
                    background-color: #1e3250;
                    transition: width 0.3s ease;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    font-weight: 500;
                }
            }
        }

        .section-progress {
            margin-top: 1rem;

            span {
                display: block;
                margin-bottom: 0.5rem;
                color: #6c757d;
            }

            .progress {
                height: 1rem;
                background-color: #e9ecef;
                border-radius: 0.5rem;
                overflow: hidden;

                .progress-bar {
                    transition: width 0.3s ease;
                }
            }
        }

        .last-saved {
            margin-top: 1rem;
            color: #6c757d;
            font-size: 0.9rem;
            display: flex;
            align-items: center;
        }
    }
  }
  
  .section-title {
    font-size: 1.25rem;
    color: #1e3250;
    margin-bottom: 1rem;
    font-weight: 600;
  }
  
  .question-item {
    margin-bottom: 1.5rem;
    padding: 1rem;
    border-left: 4px solid #1e3250;
    background: #f8f9fa;
    border-radius: 0 8px 8px 0;
  }
  
  .required-badge {
    background: #dc3545;
    color: white;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    font-size: 0.8rem;
    margin-left: 0.5rem;
  }
  
  .optional-badge {
    background: #1e3250;
    color: white;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    font-size: 0.8rem;
    margin-left: 0.5rem;
  }

  .section-status {
    display: flex;
    align-items: center;
    margin-left: auto;
    color: #1e3250;
    font-size: 0.9rem;
  }

  .section-icon {
    margin-right: 0.5rem;
    font-size: 1.2rem;
  }

  .save-section-btn {
    background: #1e3250;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: background-color 0.2s ease;
    
    &:hover {
      background: #2c4a74;
    }

    &:disabled {
      background: #ccc;
    }
  }

  .section-saved {
    color: #1e3250;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .save-status-indicator {
    z-index: 1000;
    max-width: 300px;
    
    .alert {
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      border-radius: 8px;
      margin-bottom: 0.5rem;
      padding: 0.75rem 1rem;
      font-size: 0.9rem;
      
      &.alert-info {
        background-color: rgba(13, 202, 240, 0.1);
        border-color: #0dcaf0;
        color: #0dcaf0;
      }
      
      &.alert-danger {
        background-color: rgba(220, 53, 69, 0.1);
        border-color: #dc3545;
        color: #dc3545;
      }
      
      &.alert-success {
        background-color: rgba(25, 135, 84, 0.1);
        border-color: #198754;
        color: #198754;
      }
    }
    
    .btn-sm {
      padding: 0.25rem 0.5rem;
      font-size: 0.8rem;
    }
  }

  .assessment-landing {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem;
  }

  .assessment-info-card {
    transition: transform 0.2s ease;
    border: none;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    
    &:hover {
      transform: translateY(-5px);
    }
    
    .bi {
      color: #1e3250;
    }
  }

  .step-number {
    width: 30px;
    height: 30px;
    background: #1e3250;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    flex-shrink: 0;
  }

  .start-assessment-btn {
    background: #1e3250;
    color: white;
    padding: 1rem 2rem;
    font-size: 1.2rem;
    border: none;
    border-radius: 8px;
    transition: all 0.2s ease;
    
    &:hover {
      background: #2c4a74;
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
    
    &:active {
      transform: translateY(0);
    }
  }

  .lead {
    color: #666;
    font-size: 1.2rem;
    max-width: 800px;
    margin: 0 auto;
  }

  .navigation-controls {
    display: flex;
    justify-content: space-between;
    margin-top: 2rem;
    padding: 1rem;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);

    button {
      padding: 0.75rem 1.5rem;
      font-weight: 500;
      transition: all 0.2s ease;

      &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }

  .section-awareness {
    background: white;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    margin-bottom: 2rem;

    .awareness-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1rem;

        h3 {
            color: #495057;
            margin: 0;
            font-weight: 600;
        }

        .question-count {
            display: flex;
            gap: 1rem;

            span {
                padding: 0.25rem 0.75rem;
                border-radius: 1rem;
                font-size: 0.9rem;
                font-weight: 500;

                &.required {
                    background-color: rgba(220, 53, 69, 0.1);
                    color: #dc3545;
                }

                &.optional {
                    background-color: rgba(13, 202, 240, 0.1);
                    color: #0dcaf0;
                }
            }
        }
    }

    .awareness-content {
        p {
            color: #6c757d;
            margin-bottom: 1rem;

            &.optional-info {
                display: flex;
                align-items: center;
                color: #0dcaf0;
                font-size: 0.9rem;
            }
        }
    }
  }

  .break-prompt-content {
    text-align: center;
    padding: 1rem;

    h4 {
      color: #495057;
      margin: 1rem 0;
    }

    p {
      color: #6c757d;
      margin-bottom: 0;
    }
  }

  .missed-required {
    border: 2px solid #dc3545;
    background: #fff0f0;
  }

  .completion-summary {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    margin: 2rem auto;
    max-width: 800px;

    .completion-icon {
      color: #28a745;
    }

    .completion-stats {
      .stat-item {
        text-align: center;
        padding: 1rem;
        background: #f8f9fa;
        border-radius: 8px;
        margin: 0.5rem;

        h4 {
          color: #1e3250;
          font-size: 2rem;
          font-weight: bold;
          margin: 0;
        }

        p {
          color: #6c757d;
          margin: 0.5rem 0 0 0;
          font-size: 0.9rem;
        }
      }
    }

    .completion-actions {
      .btn {
        padding: 0.75rem 1.5rem;
        font-weight: 500;
        border-radius: 8px;
        transition: all 0.2s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0,0,0,0.1);
        }
      }
    }

    .next-steps {
      border-top: 1px solid #dee2e6;
      padding-top: 2rem;
      margin-top: 2rem;

      h4 {
        color: #2c3e50;
        font-weight: 600;
      }

      .next-steps-options {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        justify-content: center;

        .btn {
          padding: 0.75rem 1.5rem;
          font-weight: 500;
          border-radius: 8px;
          transition: all 0.2s ease;
          min-width: 200px;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0,0,0,0.1);
          }

          &.btn-info {
            background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
            border: none;
            color: white;

            &:hover {
              background: linear-gradient(135deg, #138496 0%, #117a8b 100%);
            }
          }

          &.btn-outline-secondary {
            border: 2px solid #6c757d;
            color: #6c757d;

            &:hover {
              background: #6c757d;
              color: white;
            }
          }
        }
      }
    }
  }
`;

const QuestionPage = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const userId = searchParams.get('userId');

    const Indicato_ID = props.indicator_ID;
    const authToken = getToken();
    const [eventArray, setEventArray] = useState(0);

    const [isLoading, setLoading] = useState(false)
    const [isQuestionLoading, setQuestionLoading] = useState(false)
    const [sectionQues, setSectionQues] = useState([])
    const [activeKey, setActiveKey] = useState(0);
    const [savedSubmitButton, setSavedSubmitButton] = useState(false);
    const [sectionSaveStatus, setSectionSaveStatus] = useState({});
    const [isSectionSaving, setIsSectionSaving] = useState(false);
    const [completedSections, setCompletedSections] = useState({});
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

    const viewPage = location.pathname.includes('view')
    const decryptedSubId = CryptoJS.AES.decrypt(id, 'mySecretKey').toString(CryptoJS.enc.Utf8);
    const user = getUser()
    const languageUse = useSelector(selectLanguageUse || user?.language)

    const [firstIndicator, setFirstIndicator] = useState(null);
    const [overallProgress, setOverallProgress] = useState(0);
    const [currentSectionProgress, setCurrentSectionProgress] = useState(0);
    const [lastSavedTime, setLastSavedTime] = useState(null);

    const processAnswer = (item, isEnglish = true) => {
        const answers = isEnglish ? item?.answer : item?.answerFrench;
        const options = isEnglish ? item?.questionId?.options : item?.questionId?.options_French;
        const otherText = isEnglish ? 'Other' : 'Autre';
        
        if (!answers || !options) return '';
        
        return answers.map(ans => {
            const matchingOption = options.find(opt => 
                isEnglish ? opt.ans === ans : opt.ans_French === ans
            );
            return matchingOption ? ans : otherText;
        });
    };

    const { register, handleSubmit, watch, setValue, reset, control } = useForm({
        defaultValues: {
            sectionReqAnswers: [],
            sectionOptAnswers: [],
            sectionOthers: []
        }
    });

    // Watch form values for auto-save
    const watchSectionReqAnswers = watch('sectionReqAnswers');
    const watchSectionOptAnswers = watch('sectionOptAnswers');
    const watchSecOthers = watch('sectionOthers');

    const { fields: reqField } = useFieldArray({
        control,
        name: 'sectionReqAnswers'
    });

    const { fields: optField } = useFieldArray({
        control,
        name: 'sectionOptAnswers'
    });

    const [currentSection, setCurrentSection] = useState(0);
    const [sectionProgress, setSectionProgress] = useState({});
    const [autoSaveTimer, setAutoSaveTimer] = useState(null);
    const [lastAutoSave, setLastAutoSave] = useState(null);
    const [showAutoSaveIndicator, setShowAutoSaveIndicator] = useState(false);

    const [saveStatus, setSaveStatus] = useState({
        isSaving: false,
        lastSaveAttempt: null,
        lastSuccessfulSave: null,
        retryCount: 0,
        maxRetries: 3,
        error: null
    });

    const [isAssessmentComplete, setIsAssessmentComplete] = useState(false);
    const [upDocBtn, setUpDocBtn] = useState(false);

    // Add mindless selection detection
    const [answerHistory, setAnswerHistory] = useState([]);
    
    // Add ref to track if resume toast has been shown
    const resumeToastShown = useRef(false);
    const [showBreakPrompt, setShowBreakPrompt] = useState(false);

    /**
     * @function checkAssessmentCompletion
     * @description Check if entire assessment is complete by verifying all indicators are completed
     * This function will be called after saves and when checking overall completion
     */
    const checkAssessmentCompletion = async () => {
        try {
            // First check if all sections in current indicator are complete
            if (!sectionQues || sectionQues.length === 0) return false;
            
            const formValues = watch();
            let allSectionsComplete = true;
            
            // Check each section
            for (let i = 0; i < sectionQues.length; i++) {
                const section = sectionQues[i];
                const sectionReqAnswers = formValues?.sectionReqAnswers?.[i] || [];
                const requiredQuestions = section.questions.filter(q => !q.questionId?.isOptional);
                
                // Check if all required questions in this section are answered
                const sectionComplete = requiredQuestions.every((question, qIndex) => {
                    const formAnswer = sectionReqAnswers[qIndex];
                    return formAnswer && formAnswer.answer && formAnswer.answer !== '';
                });
                
                if (!sectionComplete) {
                    allSectionsComplete = false;
                    break;
                }
            }
            
            if (!allSectionsComplete) {
                return false;
            }
            
            // Fetch dimensions to find which ones are on summary
            let summaryDimensionIds = [];
            try {
                const dimensionsResult = await dimensionListService({
                    authToken,
                    filter: 'Active',
                    limit: 100,
                    offset: 0
                });
                const dimensions = dimensionsResult?.data?.data?.list || [];
                summaryDimensionIds = dimensions.filter(d => d.isOnSummary).map(d => d._id);
            } catch (dimError) {
                console.error('Error fetching dimensions:', dimError);
                // Continue without filtering - check all indicators
            }
            
            // If all sections in current indicator are complete, check all indicators via API
            const result = await indicatorListService({
                authToken,
                filter: 'Active',
                limit: 100,
                offset: 0,
                submissionId: decryptedSubId,
            });
            
            const indicators = result?.data?.data?.list || [];
            
            // Filter indicators that are on summary (main assessment indicators)
            // If we couldn't fetch dimensions, check all indicators
            const summaryIndicators = summaryDimensionIds.length > 0
                ? indicators.filter(ind => summaryDimensionIds.includes(ind.dimension?._id))
                : indicators;
            
            // Check if all summary indicators are completed
            const allIndicatorsComplete = summaryIndicators.length > 0 && 
                summaryIndicators.every(indicator => indicator.isCompleted === 'true');
            
            if (allIndicatorsComplete) {
                // Set completion flags
                setIsAssessmentComplete(true);
                setUpDocBtn(true);
                localStorage.setItem(`assessment_complete_${decryptedSubId}`, 'true');
                
                // Show completion message
                toast.success(
                    languageUse === 'English' 
                        ? '🎉 Congratulations! You have completed all assessment sections!' 
                        : '🎉 Félicitations ! Vous avez terminé toutes les sections de l\'évaluation !',
                    { duration: 5000 }
                );
                
                return true;
            }
            
            return false;
        } catch (error) {
            console.error('Error checking assessment completion:', error);
            return false;
        }
    };

    // Progress calculation function - moved here to avoid no-use-before-define error
    const calculateProgress = () => {
        if (sectionQues?.length > 0) {
            const totalQuestions = sectionQues.reduce((acc, section) => 
                acc + section.questions.length, 0);
            const answeredQuestions = sectionQues.reduce((acc, section) => 
                acc + section.questions.filter(q => q.answer !== undefined && q.answer !== null).length, 0);
            let progress = (answeredQuestions / totalQuestions) * 100;
            if (answeredQuestions < totalQuestions) {
                progress = Math.min(progress, 99);
            } else if (answeredQuestions === totalQuestions) {
                progress = 100;
            }
            setOverallProgress(progress);

            // Calculate current section progress
            if (sectionQues[currentSection]) {
                const sectionQuestions = sectionQues[currentSection].questions;
                const answeredInSection = sectionQuestions.filter(q => q.answer !== undefined && q.answer !== null).length;
                let sectionProgress = (answeredInSection / sectionQuestions.length) * 100;
                if (answeredInSection < sectionQuestions.length) {
                    sectionProgress = Math.min(sectionProgress, 99);
                } else if (answeredInSection === sectionQuestions.length) {
                    sectionProgress = 100;
                }
                setCurrentSectionProgress(sectionProgress);
            }
        }
    };

    // Track answer changes
    const trackAnswerChange = (questionId, answer) => {
        const now = Date.now();
        setAnswerHistory(prev => [...prev, { questionId, answer, timestamp: now }]);
        
        // Check for rapid answering
        const recentAnswers = answerHistory.filter(
            item => now - item.timestamp < 30000 // Last 30 seconds
        );
        
        if (recentAnswers.length >= 5) {
            const timePerAnswer = (now - recentAnswers[0].timestamp) / recentAnswers.length;
            if (timePerAnswer < 2000) { // Less than 2 seconds per answer
                setShowBreakPrompt(true);
            }
        }
    };

    // Add break prompt modal
    const BreakPrompt = () => {
        if (!showBreakPrompt) return null;

        return (
            <Modal show={showBreakPrompt} onHide={() => setShowBreakPrompt(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {languageUse === 'English' ? 'Take a Break' : 'Prenez une pause'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="break-prompt-content">
                        <i className="bi bi-clock-history fs-1 text-warning mb-3"></i>
                        <h4>
                            {languageUse === 'English'
                                ? 'You are answering questions very quickly'
                                : 'Vous répondez aux questions très rapidement'}
                        </h4>
                        <p>
                            {languageUse === 'English'
                                ? 'To ensure accurate responses, consider taking a short break. Your progress will be saved automatically.'
                                : 'Pour garantir des réponses précises, envisagez de faire une courte pause. Votre progression sera enregistrée automatiquement.'}
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowBreakPrompt(false)}>
                        {languageUse === 'English' ? 'Continue' : 'Continuer'}
                    </Button>
                    <Button variant="primary" onClick={() => {
                        setShowBreakPrompt(false);
                        // Reset answer history
                        setAnswerHistory([]);
                    }}>
                        {languageUse === 'English' ? 'Take a Break' : 'Prendre une pause'}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    /**
        * @function getQuestions
        * @param
        * @description handle API to get the Questions
    */
    const getSectionQuestions = async () => {
        try {
            setQuestionLoading(true)
            console.log('Fetching questions for indicator:', Indicato_ID);
            const result = await sectionQuestionService({
                authToken,
                indicatorId: Indicato_ID,
                submissionId: decryptedSubId,
            });
            console.log('API Response:', result?.data);


            setSectionQues(result?.data?.data)
            setQuestionLoading(false)
        } catch (error) {
            setSectionQues([])
            setQuestionLoading(false)
            toast.error(error?.response?.data?.message || 'Something went wrong')
        }
    };

    useEffect(() => {
        if (Indicato_ID) {
            getSectionQuestions()
            // Reset currentSection to 0 when indicator changes
            setCurrentSection(0)
            console.log('Indicator changed, resetting currentSection to 0')
            
            // Check if assessment is already complete when indicator changes
            // This handles the case where user navigates back to a completed assessment
            const completionStatus = localStorage.getItem(`assessment_complete_${decryptedSubId}`);
            if (completionStatus === 'true') {
                setIsAssessmentComplete(true);
                setUpDocBtn(true);
            } else {
                // Check completion status after a short delay to allow sections to load
                setTimeout(() => {
                    checkAssessmentCompletion().catch(err => {
                        console.error('Error checking completion on indicator change:', err);
                    });
                }, 1000);
            }
        }
    }, [Indicato_ID])

    /**
        * @function getAssociatedSectionQuestions
        * @param
        * @description handle API to get the Questions
    */
    const getAssociatedSectionQuestions = async () => {
        try {
            const result = await getAssociatedCompaniesSubmissionService({
                authToken,
                indicator: Indicato_ID,
                submissionId: decryptedSubId,
                userId: userId
            });
            setSectionQues(result?.data?.data)
        } catch (error) {
            setSectionQues([])
            toast.error(error?.response?.data?.message || 'Something went wrong')
        }
    };

    useEffect(() => {
        if (userId) {
            getAssociatedSectionQuestions()
        }
    }, [Indicato_ID, userId])

    /**
        * @function answerSubmit
        * @param data
        * @description api to submit the answer
    */
    const answerSubmit = async (data) => {
        setLoading(true)
        let sectionOptAnswers = []
        if (data?.sectionOptAnswers?.length > 0) {
            data?.sectionOptAnswers?.map((innerArray) => (
                sectionOptAnswers = [...sectionOptAnswers, ...innerArray.filter((obj) => Object.values(obj).every((val) => val !== null))]
            ));
        }
        let OtherSecOptionalAns = []
        if (props.currentIndicator === 'Demographics') {
            OtherSecOptionalAns = sectionOptAnswers?.map((item => (item?.answer?.length > 0 || item?.otherAnswer) && {
                id: item?.id,
                answer: ((languageUse === 'English' && item?.answer === "Other") || (languageUse === 'French' && item?.answer === "Autre")) ? item?.otherAnswer : Array.isArray(item?.answer) && item?.answer?.length > 0 ? item?.answer?.map((itemq) => {
                    return languageUse === 'English' ? itemq : sectionQues?.find(sectionItem => sectionItem?.questions?.some(question => question._id === item?.id))?.questions?.find(question => question._id === item?.id)?.questionId?.options_French[sectionQues?.find(sectionItem => sectionItem?.questions?.some(question => question._id === item?.id))?.questions?.find(question => question._id === item?.id)?.questionId?.options_French?.findIndex(optionItem => optionItem?.ans_French === itemq)]?.ans
                }) : languageUse === 'English' ? item?.answer : sectionQues?.find(sectionItem => sectionItem?.questions?.some(question => question._id === item?.id))?.questions?.find(question => question._id === item?.id)?.questionId?.options_French[sectionQues?.find(sectionItem => sectionItem?.questions?.some(question => question._id === item?.id))?.questions?.find(question => question._id === item?.id)?.questionId?.options?.findIndex(optionItem => optionItem?.ans === item?.answer)]?.ans,
                answerFrench: ((languageUse === 'English' && item?.answer === "Other") || (languageUse === 'French' && item?.answer === "Autre")) ? item?.otherAnswer : Array.isArray(item?.answer) && item?.answer?.length > 0 ? item?.answer?.map((itemq) => {
                    return languageUse === 'French' ? itemq : sectionQues?.find(sectionItem => sectionItem?.questions?.some(question => question._id === item?.id))?.questions?.find(question => question._id === item?.id)?.questionId?.options_French[sectionQues?.find(sectionItem => sectionItem?.questions?.some(question => question._id === item?.id))?.questions?.find(question => question._id === item?.id)?.questionId?.options?.findIndex(optionItem => optionItem?.ans === itemq)]?.ans_French
                }) : languageUse === 'French' ? item?.answer : sectionQues?.find(sectionItem => sectionItem?.questions?.some(question => question._id === item?.id))?.questions?.find(question => question._id === item?.id)?.questionId?.options_French[sectionQues?.find(sectionItem => sectionItem?.questions?.some(question => question._id === item?.id))?.questions?.find(question => question._id === item?.id)?.questionId?.options?.findIndex(optionItem => optionItem?.ans === item?.answer)]?.ans_French
            })).filter((item) => item?.answer && item?.id)
        } else {
            OtherSecOptionalAns = sectionOptAnswers?.map((item => (item?.answer?.length > 0 || item?.otherAnswer) && {
                id: item?.id,
                answer: ((languageUse === 'English' && item?.answer?.includes("Other")) || (languageUse === 'French' && item?.answer?.includes("Autre"))) ? item?.answer?.map((itemq) => {
                    if ((languageUse === 'English' && itemq === "Other") || (languageUse === 'French' && itemq === "Autre")) {
                        return item?.otherAnswer
                    } else {
                        return languageUse === 'English' ? itemq : sectionQues?.find(sectionItem => sectionItem?.questions?.some(question => question._id === item?.id))?.questions?.find(question => question._id === item?.id)?.questionId?.options_French[sectionQues?.find(sectionItem => sectionItem?.questions?.some(question => question._id === item?.id))?.questions?.find(question => question._id === item?.id)?.questionId?.options_French?.findIndex(optionItem => optionItem?.ans_French === itemq)]?.ans
                    }
                }) : item?.answer?.map((itemq) => {
                    return languageUse === 'English' ? itemq : sectionQues?.find(sectionItem => sectionItem?.questions?.some(question => question._id === item?.id))?.questions?.find(question => question._id === item?.id)?.questionId?.options_French[sectionQues?.find(sectionItem => sectionItem?.questions?.some(question => question._id === item?.id))?.questions?.find(question => question._id === item?.id)?.questionId?.options_French?.findIndex(optionItem => optionItem?.ans_French === itemq)]?.ans
                }),
                answerFrench: ((languageUse === 'English' && item?.answer?.includes("Other")) || (languageUse === 'French' && item?.answer?.includes("Autre"))) ? item?.answer?.map((itemq) => {
                    if ((languageUse === 'English' && itemq === "Other") || (languageUse === 'French' && itemq === "Autre")) {
                        return item?.otherAnswer
                    } else {
                        return languageUse === 'French' ? itemq : sectionQues?.find(sectionItem => sectionItem?.questions?.some(question => question._id === item?.id))?.questions?.find(question => question._id === item?.id)?.questionId?.options_French[sectionQues?.find(sectionItem => sectionItem?.questions?.some(question => question._id === item?.id))?.questions?.find(question => question._id === item?.id)?.questionId?.options?.findIndex(optionItem => optionItem?.ans === itemq)]?.ans_French
                    }
                }) : item?.answer?.map((itemq) => {
                    return languageUse === 'French' ? itemq : sectionQues?.find(sectionItem => sectionItem?.questions?.some(question => question._id === item?.id))?.questions?.find(question => question._id === item?.id)?.questionId?.options_French[sectionQues?.find(sectionItem => sectionItem?.questions?.some(question => question._id === item?.id))?.questions?.find(question => question._id === item?.id)?.questionId?.options?.findIndex(optionItem => optionItem?.ans === itemq)]?.ans_French
                })
            })).filter((item) => item?.answer && item?.id)
        }
        let sectionReqAnswers = []
        if (data?.sectionReqAnswers?.length > 0) {
            data?.sectionReqAnswers?.map((innerArray) => (
                sectionReqAnswers = [...sectionReqAnswers, ...innerArray.filter((obj) => Object.values(obj).every((val) => val !== null))]
            ));
        }
        const sectionReqAnswers2 = sectionReqAnswers?.map((item) => {
            if (item?.answer?.length > 0) {
                return {
                    answer: languageUse === 'English' ? [item?.answer] : [item?.answer === 'Oui' ? 'yes' : 'no'],
                    answerFrench: languageUse === 'English' ? [item?.answer === 'yes' ? 'Oui' : 'Non'] : [item?.answer],
                    id: item?.id
                }
            }
        }).filter((item) => item?.answer?.length > 0)

        let finalAnswersData = []

        if (props.currentIndicator === 'Demographics') {
            finalAnswersData = sectionReqAnswers2.concat(OtherSecOptionalAns?.map((item) => {
                return {
                    answer: Array.isArray(item?.answer) ? item?.answer : [item?.answer],
                    answerFrench: Array.isArray(item?.answerFrench) ? item?.answerFrench : [item?.answerFrench],
                    id: item?.id
                }
            }));
        } else {
            finalAnswersData = sectionReqAnswers2.concat(OtherSecOptionalAns);
        }

        try {
            const result = await userAnswerService({
                authToken,
                data: finalAnswersData.filter((item => item.answer && item.id))
            });
            toast.success(result?.data?.data?.message)
            props.setChangeIndicatorName(!props.changeIndicatorName)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            toast.error(error?.response?.data?.message || 'Something went wrong')
        }
    };

    /**
        * @function onSubmit
        * @param data
        * @description submit the answer
    */
    const onSubmit = async (data) => {
        console.log('Form submitted with data:', data);
        console.log('Assessment completion status:', isAssessmentComplete);
        console.log('Current section questions:', sectionQues);
        
        if (!isAssessmentComplete) {
            toast.error(languageUse === 'English' 
                ? 'Please complete all questions before proceeding' 
                : 'Veuillez répondre à toutes les questions avant de continuer');
            return;
        }

        const confirmed = window.confirm(
            languageUse === 'English' 
                ? 'You have completed all questions. Would you like to proceed to the next step (document upload)?' 
                : 'Vous avez terminé toutes les questions. Voulez-vous passer à l\'étape suivante (téléchargement de documents)?'
        );
        
        if (confirmed) {
            // Navigate to upload documents page
            const encryptedId = CryptoJS.AES.encrypt(decryptedSubId, 'mySecretKey').toString();
            navigate(`/uploadDocuments/${encodeURIComponent(encryptedId)}`);
        }
    };

    /**
        * @function handleReset
        * @param
        * @description reset all form data
    */
    const handleReset = () => {
        // Add user confirmation
        const confirmed = window.confirm(
            languageUse === 'English' 
                ? 'This will clear all answers in this section. Are you sure you want to reset?' 
                : 'Cela effacera toutes les réponses de cette section. Êtes-vous sûr de vouloir réinitialiser?'
        );

        if (!confirmed) {
            return;
        }

        try {
            // Reset form
            reset();
            
            // Clear any saved progress for this section only if not completed
            const savedProgress = localStorage.getItem(`assessment_progress_${decryptedSubId}`);
            if (savedProgress) {
                const parsed = JSON.parse(savedProgress);
                const updatedSectionStatus = { ...parsed.sectionStatus };
                const updatedCompletedSections = { ...parsed.completedSections };
                // Only delete if not completed
                if (!updatedCompletedSections[currentSection]) {
                    if (updatedSectionStatus[currentSection]) {
                        delete updatedSectionStatus[currentSection];
                    }
                    if (updatedCompletedSections[currentSection]) {
                        delete updatedCompletedSections[currentSection];
                    }
                }
                localStorage.setItem(`assessment_progress_${decryptedSubId}`, JSON.stringify({
                    ...parsed,
                    sectionStatus: updatedSectionStatus,
                    completedSections: updatedCompletedSections,
                    lastSave: new Date().getTime()
                }));
            }
            // Update local state
            setSectionSaveStatus(prev => {
                const updated = { ...prev };
                if (!completedSections[currentSection]) {
                    delete updated[currentSection];
                }
                return updated;
            });
            setCompletedSections(prev => {
                const updated = { ...prev };
                if (!prev[currentSection]) {
                    delete updated[currentSection];
                }
                return updated;
            });
            // Reset saved submit button status
            setSavedSubmitButton(false);
            // Recalculate progress
            calculateProgress();
        } catch (error) {
            toast.error(languageUse === 'English' ? 'Failed to reset section.' : 'Échec de la réinitialisation de la section.');
        }
    };

    useEffect(() => {
        if (sectionQues) {
            setActiveKey(0)
            reset()
            let tempStatus = false

            const defaultValues = {};

            let secOptDeafultValues = []

            if (sectionQues?.length > 0 && props.currentIndicator !== 'Demographics') {
                sectionQues.filter(item => item?.questions?.filter(itemq => itemq?.questionId?.isOptional).length > 0).map(itemq => {
                    let temp = []
                    temp = itemq.questions.filter(item => item.isOptional).map(item => ({
                        answer: processAnswer(item, languageUse === 'English'),
                        id: item?._id,
                        otherAnswer: item?.answer?.find(ans => 
                            !item?.questionId?.options?.some(opt => opt.ans === ans)
                        ) || ''
                    }))
                    secOptDeafultValues = [...secOptDeafultValues, temp]
                })
                defaultValues.sectionOptAnswers = secOptDeafultValues;
            }

            if (sectionQues?.length > 0 && props.currentIndicator === 'Demographics') {
                sectionQues.filter(item => item?.questions?.filter(itemq => itemq?.questionId?.isOptional).length > 0).map(itemq => {
                    let temp = []
                    temp = itemq.questions.filter(item => item.isOptional).map(item => ({
                        answer: processAnswer(item, languageUse === 'English'),
                        id: item?._id,
                        otherAnswer: item?.answer?.find(ans => 
                            !item?.questionId?.options?.some(opt => opt.ans === ans)
                        ) || ''
                    }))
                    secOptDeafultValues = [...secOptDeafultValues, temp]
                })
                defaultValues.sectionOptAnswers = secOptDeafultValues;
            }

            let secReqDeafultValues = []

            if (sectionQues?.length > 0) {
                sectionQues.filter(item => item?.questions?.filter(itemq => !itemq?.questionId?.isOptional).length > 0).map(itemq => {
                    let temp = []
                    temp = itemq.questions.filter(item => !item.isOptional).map((item => {
                        return {
                            answer: languageUse === 'English' && item?.answer?.length > 0 ? item?.answer[0] : languageUse === 'French' && item?.answerFrench?.length > 0 ? item?.answerFrench[0] : '',
                            id: item?._id,
                        }
                    }))
                    secReqDeafultValues = [...secReqDeafultValues, temp]
                })

                defaultValues.sectionReqAnswers = secReqDeafultValues;
            }

            tempStatus = secOptDeafultValues?.some(item => item?.some(innerItem => innerItem?.answer?.length > 0)) || secReqDeafultValues?.some(item => item?.some(innerItem => innerItem?.answer?.length > 0))
            setSavedSubmitButton(tempStatus)
            reset({ ...defaultValues })
        }
    }, [sectionQues, languageUse])

    /**
     * @function saveSection
     * @param index
     * @description Save the current section's answers
     */
    const saveSection = async (index, data) => {
        setSaveStatus(prev => ({
            ...prev,
            isSaving: true,
            lastSaveAttempt: new Date().getTime(),
            error: null
        }));

        const sectionData = {
            sectionOptAnswers: data?.sectionOptAnswers?.[index] || [],
            sectionReqAnswers: data?.sectionReqAnswers?.[index] || []
        };

        try {
            console.log('Saving section:', index, 'with data:', sectionData);
            
            // Validate section completion
            const section = sectionQues[index];
            const totalQuestions = (section?.questions?.filter(q => !q?.questionId?.isOptional)?.length || 0) + 
                                 (section?.questions?.filter(q => q?.questionId?.isOptional)?.length || 0);
            const answeredQuestions = [...sectionData.sectionReqAnswers, ...sectionData.sectionOptAnswers]
                .filter(item => item?.answer && item?.id).length;
            
            const completionPercentage = totalQuestions > 0 ? Math.min((answeredQuestions / totalQuestions) * 100, 100) : 0;
            
            console.log('Section completion stats:', {
                totalQuestions,
                answeredQuestions,
                completionPercentage,
                sectionData
            });

            // Save to backend with retry logic
            let retryCount = 0;
            let lastError = null;
            
            while (retryCount < saveStatus.maxRetries) {
                try {
                    const result = await userAnswerService({
                        authToken,
                        data: [...sectionData.sectionReqAnswers, ...sectionData.sectionOptAnswers].filter(item => item?.answer && item?.id)
                    });
                    
                    // Update section status
                    const newSectionStatus = {
                        ...sectionSaveStatus,
                        [index]: true
                    };
                    setSectionSaveStatus(newSectionStatus);
                    
                    // Mark section as completed if it has all required answers
                    const hasAllRequired = sectionData.sectionReqAnswers.every(item => item?.answer);
                    const newCompletedSections = {
                        ...completedSections,
                        [index]: hasAllRequired
                    };
                    setCompletedSections(newCompletedSections);
                    
                    // Save progress to localStorage
                    localStorage.setItem(`assessment_progress_${decryptedSubId}`, JSON.stringify({
                        sectionStatus: newSectionStatus,
                        completedSections: newCompletedSections,
                        completionPercentage,
                        lastSave: new Date().getTime()
                    }));
                    
                    setSaveStatus(prev => ({
                        ...prev,
                        isSaving: false,
                        lastSuccessfulSave: new Date().getTime(),
                        retryCount: 0,
                        error: null
                    }));
                    
                    // Only show toast for manual saves, not auto-saves
                    if (!data.isAutoSave) {
                        toast.success(languageUse === 'English' ? 'Section saved successfully' : 'Section enregistrée avec succès');
                    }
                    
                    // Check if assessment is complete after successful save (only for manual saves to avoid excessive API calls)
                    if (!data.isAutoSave && hasAllRequired) {
                        // Use setTimeout to avoid blocking the save response
                        setTimeout(() => {
                            checkAssessmentCompletion().catch(err => {
                                console.error('Error checking completion after save:', err);
                            });
                        }, 500);
                    }
                    
                    return;
                } catch (error) {
                    lastError = error;
                    retryCount++;
                    
                    if (retryCount < saveStatus.maxRetries) {
                        // Wait before retrying
                        await new Promise(resolve => setTimeout(resolve, 1000 * retryCount));
                    }
                }
            }
            
            if (retryCount >= saveStatus.maxRetries) {
                throw lastError;
            }
        } catch (error) {
            console.error('Section save error:', error);
            setSaveStatus(prev => ({
                ...prev,
                isSaving: false,
                error: error?.response?.data?.message || 'Failed to save section. Please try again.',
                retryCount: prev.retryCount + 1
            }));
            toast.error(error?.response?.data?.message || 'Failed to save section. Please try again.');
        }
    };

        // Function to refresh section data and update state
    const refreshSectionData = async () => {
        try {
            const result = await sectionQuestionService({
                authToken,
                indicatorId: Indicato_ID,
                submissionId: decryptedSubId,
            });
            if (result?.data?.data) {
                const newSectionCount = result.data.data.length;
                if (newSectionCount !== sectionQues.length) {
                    console.log(`Refreshing sections: ${sectionQues.length} → ${newSectionCount}`);
                    setSectionQues(result.data.data);
                    return newSectionCount;
                }
            }
        } catch (error) {
            console.log('Could not refresh section data:', error);
        }
        return sectionQues.length;
    };

    // Enhanced navigation that handles both section and pillar navigation
    const handleSectionNavigation = async (direction) => {
        // Set loading state
        setIsSectionSaving(true);
        
        try {
        // Save current section before navigating
        await saveSection(currentSection, watch());
        
        // Re-check for available sections after saving (in case API returns more sections)
        const updatedSectionCount = await refreshSectionData();
        
        // Debug logging to understand the structure
        console.log('Navigation Debug:', {
            direction,
            currentSection,
            sectionQuesLength: sectionQues?.length,
            updatedSectionCount,
            currentIndicator: props.currentIndicator
        });
        
        if (direction === 'next') {
            // Check if we're at the last section of the current indicator
            if (currentSection === updatedSectionCount - 1) {
                // We're at the last section of this indicator, trigger next indicator progression
                console.log('At last section of current indicator, triggering next indicator');
                
                // Check if this is Demographics (which only has 1 section) or a regular topic
                const isDemographics = props.currentIndicator === 'Demographics';
                
                console.log('Topic completion:', {
                    topic: props.currentIndicator,
                    isDemographics,
                    sectionsCompleted: updatedSectionCount,
                    currentSection
                });
                
                if (isDemographics) {
                    // Demographics has 1 section, move to next topic
                    console.log('Demographics completed, moving to next topic');
                    if (props.setChangeIndicatorName) {
                        props.setChangeIndicatorName(prev => !prev);
                        toast.success(
                            languageUse === 'English' 
                                ? 'Moving to next assessment topic...' 
                                : 'Passage au sujet d\'évaluation suivant...',
                            { duration: 3000 }
                        );
                    }
                } else {
                    // For all other topics, they should have 5 sections
                    // Check if we have all 5 sections or just 1 section from the API
                    const expectedSections = 5;
                    const actualSections = updatedSectionCount;
                    
                    if (actualSections >= expectedSections) {
                        // We have all 5 sections, this is truly the last section
                        console.log(`${props.currentIndicator} has all ${expectedSections} sections, moving to next topic`);
                        if (props.setChangeIndicatorName) {
                            props.setChangeIndicatorName(prev => !prev);
                            toast.success(
                                languageUse === 'English' 
                                    ? 'Moving to next assessment topic...' 
                                    : 'Passage au sujet d\'évaluation suivant...',
                                { duration: 3000 }
                            );
                        }
                    } else {
                        // API only returned partial sections, but we should have 5
                        // For now, move to next topic, but log this as an API issue
                        console.log(`API Issue: ${props.currentIndicator} should have ${expectedSections} sections but only got ${actualSections}`);
                        console.log('Moving to next topic due to incomplete section data');
                        
                        if (props.setChangeIndicatorName) {
                            props.setChangeIndicatorName(prev => !prev);
                            toast.success(
                                languageUse === 'English' 
                                    ? 'Moving to next assessment topic...' 
                                    : 'Passage au sujet d\'évaluation suivant...',
                                { duration: 3000 }
                            );
                        }
                    }
                }
            } else {
                // Move to next section within current indicator
                const nextSection = currentSection + 1;
                console.log('Moving to next section:', nextSection);
                setCurrentSection(nextSection);
                    
                    // If moving to last section, check completion after a delay
                    if (nextSection === updatedSectionCount - 1) {
                        setTimeout(() => {
                            checkAssessmentCompletion().catch(err => {
                                console.error('Error checking completion on last section:', err);
                            });
                        }, 2000);
                    }
                
                // Force a re-render and scroll after state update
                setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }, 100);
                
                toast.success(
                    languageUse === 'English' 
                        ? `Moving to section ${nextSection + 1}` 
                        : `Passage à la section ${nextSection + 1}`,
                    { duration: 2000 }
                );
            }
        } else if (direction === 'prev') {
            if (currentSection === 0) {
                // We're at the first section, try to move to previous indicator
                toast.info(
                    languageUse === 'English' 
                        ? 'You are at the first section. Use the navigation menu above to select a different topic.' 
                        : 'Vous êtes à la première section. Utilisez le menu de navigation ci-dessus pour sélectionner un sujet différent.',
                        { duration: 3000 }
                );
            } else {
                // Move to previous section within current indicator
                const prevSection = currentSection - 1;
                console.log('Moving to previous section:', prevSection);
                setCurrentSection(prevSection);
                
                // Force a re-render and scroll after state update
                setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }, 100);
                
                toast.success(
                    languageUse === 'English' 
                        ? `Moving to section ${prevSection + 1}` 
                        : `Passage à la section ${prevSection + 1}`,
                        { duration: 2000 }
                );
            }
            }
        } catch (error) {
            console.error('Navigation error:', error);
            toast.error(languageUse === 'English' 
                ? 'An error occurred during navigation. Please try again.' 
                : 'Une erreur s\'est produite lors de la navigation. Veuillez réessayer.');
        } finally {
            setIsSectionSaving(false);
        }
    };

    // Also, in useEffect for loading saved progress, ensure answers are restored for the current section
    useEffect(() => {
        const loadSavedProgress = () => {
            const savedProgress = localStorage.getItem(`assessment_progress_${decryptedSubId}`);
            if (savedProgress) {
                const parsed = JSON.parse(savedProgress);
                setSectionSaveStatus(parsed.sectionStatus || {});
                setCompletedSections(parsed.completedSections || {});
                if (parsed.answers && parsed.answers[currentSection]) {
                    reset(parsed.answers[currentSection]);
                }
            }
        };
        if (decryptedSubId) {
            loadSavedProgress();
        }
    }, [decryptedSubId, currentSection]);

    // Note: Automatic completion detection removed to prevent premature assessment completion

    // Note: Automatic completion status loading removed to prevent premature completion

    // Update activeKey when currentSection changes to ensure Accordion expands the correct section
    useEffect(() => {
        setActiveKey(currentSection);
    }, [currentSection]);
    
    // Update the useEffect for checking assessment started status
    useEffect(() => {
        if (sectionQues?.length > 0 && !firstIndicator) {
            setFirstIndicator(props.currentIndicator);
            
            // Clear any existing completion status when starting a new assessment
            const existingCompletion = localStorage.getItem(`assessment_complete_${decryptedSubId}`);
            if (existingCompletion === 'true') {
                console.log('Clearing existing completion status for new assessment');
                localStorage.removeItem(`assessment_complete_${decryptedSubId}`);
                setIsAssessmentComplete(false);
                setUpDocBtn(false);
            }
        }
    }, [decryptedSubId, sectionQues, props.currentIndicator]);

    /**
     * @function resetAssessmentCompletion
     * @description Manually reset assessment completion status
     */
    const resetAssessmentCompletion = () => {
        localStorage.removeItem(`assessment_complete_${decryptedSubId}`);
        setIsAssessmentComplete(false);
        setUpDocBtn(false);
        toast.success(languageUse === 'English' ? 'Assessment completion status reset' : 'Statut de completion de l\'évaluation réinitialisé');
    };

    /**
     * @function startNewAssessment
     * @description Clear all data and start fresh assessment
     */
    const startNewAssessment = () => {
        // Clear all localStorage data for this assessment
        const keysToRemove = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.includes(decryptedSubId)) {
                keysToRemove.push(key);
            }
        }
        
        keysToRemove.forEach(key => localStorage.removeItem(key));
        
        // Reset component state
        setIsAssessmentComplete(false);
        setUpDocBtn(false);
        setSectionSaveStatus({});
        setCompletedSections({});
        setCurrentSection(0);
        
        // Reset form
        reset();
        
        toast.success(languageUse === 'English' ? 'Starting fresh assessment' : 'Démarrage d\'une nouvelle évaluation');
    };

    /**
     * @function clearAllAssessmentData
     * @description Clear all localStorage data for this assessment
     */
    const clearAllAssessmentData = () => {
        // Clear all localStorage keys related to this submission
        const keysToRemove = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.includes(decryptedSubId)) {
                keysToRemove.push(key);
            }
        }
        
        keysToRemove.forEach(key => localStorage.removeItem(key));
        
        // Reset component state
        setIsAssessmentComplete(false);
        setUpDocBtn(false);
        setSectionSaveStatus({});
        setCompletedSections({});
        
        toast.success(languageUse === 'English' ? 'All assessment data cleared' : 'Toutes les données d\'évaluation effacées');
        
        // Reload the page to start fresh
        window.location.reload();
    };

    /**
        * @function backToprevPage
        * @param ()
        * @description back To previous Page
    */
    const backToprevPage = () => {
        navigate('/')
    }

    useEffect(() => {
        setEventArray(Array.from({ length: sectionQues?.length }, (_, i) => (i)))
    }, [sectionQues])

    /**
     * @function handleResyncQuestions
     * @description Resyncs questions for the current submission
     */
    const handleResyncQuestions = async () => {
        // Prevent multiple simultaneous calls
        if (isQuestionLoading) {
            toast.error(languageUse === 'English' ? 'Resync already in progress' : 'Resynchronisation déjà en cours');
            return;
        }

        // Add user confirmation
        const confirmed = window.confirm(
            languageUse === 'English' 
                ? 'This will refresh all questions for this section. Any unsaved changes will be lost. Continue?' 
                : 'Cela actualisera toutes les questions de cette section. Toutes les modifications non enregistrées seront perdues. Continuer?'
        );

        if (!confirmed) {
            return;
        }

        try {
            setQuestionLoading(true);
            const baseUrl = process.env.REACT_APP_API_BASEURL;
            const endpoint = `${baseUrl}api/questions/resync/${decryptedSubId}`;
            
            console.log('Attempting to resync questions with:', {
                baseUrl,
                endpoint,
                submissionId: decryptedSubId,
                hasAuthToken: !!authToken
            });
            
            const response = await axios.post(endpoint, {}, {
                headers: {
                    Authorization: `Bearer ${authToken}`
                },
                timeout: 30000 // 30 second timeout
            });
            
            console.log('Resync API Response:', response);
            
            if (response?.data?.statusCode === 200) {
                // Refetch questions after resync
                await getSectionQuestions();
                toast.success(languageUse === 'English' ? 'Questions resynced successfully' : 'Questions resynchronisées avec succès');
            } else {
                throw new Error(response?.data?.message || 'Resync failed');
            }
        } catch (error) {
            console.error('Error resyncing questions:', {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
                config: {
                    url: error.config?.url,
                    method: error.config?.method,
                    headers: error.config?.headers
                }
            });

            // Provide more specific error messages
            let errorMessage = languageUse === 'English' ? 'Failed to resync questions' : 'Échec de la resynchronisation des questions';
            
            if (error.code === 'ECONNABORTED') {
                errorMessage = languageUse === 'English' ? 'Request timed out. Please try again.' : 'Délai d\'attente dépassé. Veuillez réessayer.';
            } else if (error.response?.status === 401) {
                errorMessage = languageUse === 'English' ? 'Authentication failed. Please log in again.' : 'Échec de l\'authentification. Veuillez vous reconnecter.';
            } else if (error.response?.status === 404) {
                errorMessage = languageUse === 'English' ? 'Assessment not found. Please refresh the page.' : 'Évaluation introuvable. Veuillez actualiser la page.';
            } else if (error.response?.status >= 500) {
                errorMessage = languageUse === 'English' ? 'Server error. Please try again later.' : 'Erreur serveur. Veuillez réessayer plus tard.';
            } else if (error.response?.data?.message) {
                errorMessage = error.response.data.message;
            }

            toast.error(errorMessage);
        } finally {
            setQuestionLoading(false);
        }
    };

    // Update progress calculation when answers change
    useEffect(() => {
        calculateProgress();
    }, [sectionQues, currentSection]);

    // Add auto-save functionality
    useEffect(() => {
        // Don't auto-save if manual save is in progress or if section is saving
        if (saveStatus.isSaving || isSectionSaving) {
            return;
        }

        if (watchSectionReqAnswers || watchSectionOptAnswers) {
            // Clear existing timer
            if (autoSaveTimer) {
                clearTimeout(autoSaveTimer);
            }

            // Set new timer for auto-save with debouncing
            const timer = setTimeout(() => {
                // Double-check that we're not saving before auto-saving
                if (!saveStatus.isSaving && !isSectionSaving) {
                    saveSection(currentSection, { 
                        sectionReqAnswers: watchSectionReqAnswers,
                        sectionOptAnswers: watchSectionOptAnswers,
                        sectionOthers: watchSecOthers,
                        isAutoSave: true
                    });
                    setLastAutoSave(new Date());
                    setShowAutoSaveIndicator(true);
                    // Hide auto-save indicator after 3 seconds
                    setTimeout(() => {
                        setShowAutoSaveIndicator(false);
                    }, 3000);
                }
            }, 30000); // Auto-save after 30 seconds of inactivity

            setAutoSaveTimer(timer);
        }

        return () => {
            if (autoSaveTimer) {
                clearTimeout(autoSaveTimer);
            }
        };
    }, [watchSectionReqAnswers, watchSectionOptAnswers, watchSecOthers, currentSection, saveStatus.isSaving, isSectionSaving]);

    // Add section validation function
    const validateCurrentSection = () => {
        if (!sectionQues[currentSection]) return true;
        
        const requiredQuestions = sectionQues[currentSection].questions.filter(q => !q.questionId?.isOptional);
        const answeredRequiredQuestions = requiredQuestions.filter(q => q.answer !== undefined && q.answer !== null);
        
        return answeredRequiredQuestions.length === requiredQuestions.length;
    };

    // Add auto-save indicator
    const AutoSaveIndicator = () => (
        <div className="auto-save-indicator position-fixed bottom-0 end-0 p-2">
            {showAutoSaveIndicator && lastAutoSave && (
                <div className="alert alert-success mb-0">
                    <i className="bi bi-check-circle me-2"></i>
                    {languageUse === 'English' ? 'Auto-saved' : 'Enregistrement automatique'}
                </div>
            )}
        </div>
    );

    // Add retry logic for failed saves
    const retrySave = async () => {
        if (saveStatus.retryCount < saveStatus.maxRetries) {
            setSaveStatus(prev => ({
                ...prev,
                retryCount: prev.retryCount + 1,
                error: null
            }));
            await saveSection(currentSection, {
                sectionReqAnswers: watchSectionReqAnswers,
                sectionOptAnswers: watchSectionOptAnswers,
                sectionOthers: watchSecOthers
            });
        }
    };

    // Add save status indicator component
    const SaveStatusIndicator = () => (
        <div className="save-status-indicator position-fixed bottom-0 end-0 p-2">
            {saveStatus.isSaving && (
                <div className="alert alert-info mb-0">
                    <BootstrapSpinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                    />
                    {languageUse === 'English' ? 'Saving...' : 'Enregistrement...'}
                </div>
            )}
            {saveStatus.error && (
                <div className="alert alert-danger mb-0">
                    <i className="bi bi-exclamation-triangle me-2"></i>
                    {saveStatus.error}
                    {saveStatus.retryCount < saveStatus.maxRetries && (
                        <button 
                            className="btn btn-sm btn-outline-danger ms-2"
                            onClick={() => retrySave()}
                        >
                            {languageUse === 'English' ? 'Retry' : 'Réessayer'}
                        </button>
                    )}
                </div>
            )}
            {saveStatus.lastSuccessfulSave && !saveStatus.isSaving && !saveStatus.error && (
                <div className="alert alert-success mb-0">
                    <i className="bi bi-check-circle me-2"></i>
                    {languageUse === 'English' ? 'Last saved' : 'Dernier enregistrement'}: {new Date(saveStatus.lastSuccessfulSave).toLocaleTimeString()}
                </div>
            )}
        </div>
    );

    // Add section awareness component
    const SectionAwareness = ({ section }) => {
        if (!section) return null;

        const requiredCount = section.questions.filter(q => !q.questionId?.isOptional).length;
        const optionalCount = section.questions.filter(q => q.questionId?.isOptional).length;

        // Get section-specific description based on section name
        const getSectionDescription = () => {
            const sectionName = section.sectionId?.name || '';
            
            if (languageUse === 'English') {
                switch (sectionName.toLowerCase()) {
                    case 'demographics':
                        return 'This section collects basic information about your company, including size, location, and industry. This helps us understand your business context and provide relevant recommendations.';
                    case 'environment':
                        return 'This section evaluates your company\'s environmental impact and sustainability practices, including energy use, waste management, and carbon emissions. Your responses will help identify opportunities for environmental improvement.';
                    case 'social':
                        return 'This section assesses your company\'s social impact, including employee relations, community engagement, and diversity initiatives. Your responses will help us understand your social responsibility practices.';
                    case 'governance':
                        return 'This section examines your company\'s governance structure, policies, and ethical practices. Your responses will help evaluate your corporate governance framework and identify areas for enhancement.';
                    default:
                        return 'This section helps us understand your current practices and identify areas for improvement. Please answer all required questions to proceed.';
                }
            } else {
                switch (sectionName.toLowerCase()) {
                    case 'demographics':
                        return 'Cette section collecte des informations de base sur votre entreprise, notamment sa taille, son emplacement et son secteur d\'activité. Cela nous aide à comprendre votre contexte commercial et à fournir des recommandations pertinentes.';
                    case 'environment':
                        return 'Cette section évalue l\'impact environnemental et les pratiques de durabilité de votre entreprise, y compris la consommation d\'énergie, la gestion des déchets et les émissions de carbone. Vos réponses aideront à identifier les opportunités d\'amélioration environnementale.';
                    case 'social':
                        return 'Cette section évalue l\'impact social de votre entreprise, y compris les relations avec les employés, l\'engagement communautaire et les initiatives de diversité. Vos réponses nous aideront à comprendre vos pratiques de responsabilité sociale.';
                    case 'governance':
                        return 'Cette section examine la structure de gouvernance, les politiques et les pratiques éthiques de votre entreprise. Vos réponses aideront à évaluer votre cadre de gouvernance d\'entreprise et à identifier les domaines à améliorer.';
                    default:
                        return 'Cette section nous aide à comprendre vos pratiques actuelles et à identifier les domaines à améliorer. Veuillez répondre à toutes les questions requises pour continuer.';
                }
            }
        };

        const sectionDescription = getSectionDescription();

        return (
            <div className="section-awareness">
                <div className="awareness-header">
                    <h3>{languageUse === 'English' ? 'Section Overview' : 'Aperçu de la section'}</h3>
                    <div className="question-count">
                        <span className="required">
                            {requiredCount} {languageUse === 'English' ? 'required' : 'requises'}
                        </span>
                        {optionalCount > 0 && (
                            <span className="optional">
                                {optionalCount} {languageUse === 'English' ? 'optional' : 'optionnelles'}
                            </span>
                        )}
                    </div>
                </div>
                <div className="awareness-content">
                    <p>{sectionDescription}</p>
                    {optionalCount > 0 && (
                        <p className="optional-info">
                            <i className="bi bi-info-circle me-2"></i>
                            {languageUse === 'English'
                                ? 'Optional questions provide additional context and help us better understand your specific situation.'
                                : 'Les questions optionnelles fournissent un contexte supplémentaire et nous aident à mieux comprendre votre situation spécifique.'}
                        </p>
                    )}
                </div>
            </div>
        );
    };

    useEffect(() => {
        // Resume where left off logic
        const savedProgress = localStorage.getItem(`assessment_progress_${decryptedSubId}`);
        const completionStatus = localStorage.getItem(`assessment_complete_${decryptedSubId}`);
        
        // Determine assessment type
        const isProgressAssessment = location.pathname.includes('/progress/') || props.currentIndicator?.includes('Progress');
        const isReadinessAssessment = !isProgressAssessment;
        
        // Check if assessment is already marked as complete
        if (completionStatus === 'true') {
            setIsAssessmentComplete(true);
            setUpDocBtn(true);
        }
        
        if (savedProgress && sectionQues.length > 0 && !resumeToastShown.current) {
            const parsed = JSON.parse(savedProgress);
            // Find the first incomplete section
            let lastIncompleteSection = 0;
            if (parsed.sectionStatus) {
                for (let i = 0; i < sectionQues.length; i++) {
                    if (!parsed.sectionStatus[i]) {
                        lastIncompleteSection = i;
                        break;
                    }
                }
            }
            setCurrentSection(lastIncompleteSection);
            // Show a toast or modal only once
            toast.dismiss();
            toast(
                (t) => React.createElement(
                    'span',
                    null,
                    languageUse === 'English'
                        ? `Resuming ${isReadinessAssessment ? 'Readiness' : 'Progress'} Assessment: Section ${lastIncompleteSection + 1}`
                        : `Reprise de l'évaluation ${isReadinessAssessment ? 'de préparation' : 'des progrès'} : Section ${lastIncompleteSection + 1}`,
                    React.createElement(
                        'button',
                        {
                            onClick: () => toast.dismiss(t.id),
                            style: { marginLeft: '1rem', background: 'none', border: 'none', color: '#0d6efd', cursor: 'pointer' }
                        },
                        'OK'
                    )
                ),
                { duration: 6000 }
            );
            
            // Mark that the toast has been shown
            resumeToastShown.current = true;
        }
    }, [decryptedSubId, sectionQues.length, navigate, location.pathname, props.currentIndicator]);

    // Helper to filter unique questions by _id
    const getUniqueQuestions = (questions) => {
        const seen = new Set();
        return questions.filter(q => {
            if (!q?.questionId?._id) return true;
            if (seen.has(q.questionId._id)) return false;
            seen.add(q.questionId._id);
            return true;
        });
    };

    // Helper to find missed required questions in the current section - FIXED: Check form state instead of sectionQues
    const getMissedRequiredQuestions = () => {
        if (!sectionQues[currentSection]) return [];
        
        // Get form values for current section
        const formValues = watch();
        const sectionReqAnswers = formValues?.sectionReqAnswers?.[currentSection] || [];
        
        // Get required questions for current section
        const requiredQuestions = sectionQues[currentSection].questions.filter(q => !q.questionId?.isOptional);
        
        // Check which required questions are not answered in form
        const missedQuestions = requiredQuestions.filter((question, qIndex) => {
            const formAnswer = sectionReqAnswers[qIndex];
            return !formAnswer || !formAnswer.answer || formAnswer.answer === '';
        });
        
        return missedQuestions;
    };

    /**
     * @function checkCurrentSectionCompletion
     * @description Check if current section has all required questions answered
     * @returns {boolean} True if section is complete
     */
    const checkCurrentSectionCompletion = () => {
        if (!sectionQues[currentSection]) return false;
        
        const formValues = watch();
        const sectionReqAnswers = formValues?.sectionReqAnswers?.[currentSection] || [];
        const requiredQuestions = sectionQues[currentSection].questions.filter(q => !q.questionId?.isOptional);
        
        // Check if all required questions have answers
        const allRequiredAnswered = requiredQuestions.every((question, qIndex) => {
            const formAnswer = sectionReqAnswers[qIndex];
            return formAnswer && formAnswer.answer && formAnswer.answer !== '';
        });
        
        return allRequiredAnswered;
    };

    /**
     * @function checkAllSectionsCompletion
     * @description Check if all sections in current indicator are completed
     * @returns {boolean} True if all sections are complete
     */
    const checkAllSectionsCompletion = () => {
        if (!sectionQues || sectionQues.length === 0) return false;
        
        const formValues = watch();
        
        // Check each section
        for (let i = 0; i < sectionQues.length; i++) {
            const section = sectionQues[i];
            const sectionReqAnswers = formValues?.sectionReqAnswers?.[i] || [];
            const requiredQuestions = section.questions.filter(q => !q.questionId?.isOptional);
            
            // Check if all required questions in this section are answered
            const sectionComplete = requiredQuestions.every((question, qIndex) => {
                const formAnswer = sectionReqAnswers[qIndex];
                return formAnswer && formAnswer.answer && formAnswer.answer !== '';
            });
            
            if (!sectionComplete) {
                return false;
            }
        }
        
        return true;
    };


    // Add completion summary component
    const CompletionSummary = () => {
        if (!isAssessmentComplete) return null;

        // Determine assessment type based on URL or props
        const isProgressAssessment = location.pathname.includes('/progress/') || props.currentIndicator?.includes('Progress');
        const isReadinessAssessment = !isProgressAssessment;

        return (
            <div className="completion-summary">
                <div className="text-center p-5">
                    <div className="completion-icon mb-4">
                        <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '4rem' }}></i>
                    </div>
                    <h2 className="mb-3">
                        {languageUse === 'English' 
                            ? `${isReadinessAssessment ? 'Readiness' : 'Progress'} Assessment Completed!` 
                            : `Évaluation ${isReadinessAssessment ? 'de préparation' : 'des progrès'} terminée !`}
                    </h2>
                    <p className="lead mb-4">
                        {languageUse === 'English' 
                            ? `Congratulations! You have successfully completed all sections of your ${isReadinessAssessment ? 'Readiness' : 'Progress'} assessment.`
                            : `Félicitations ! Vous avez terminé avec succès toutes les sections de votre évaluation ${isReadinessAssessment ? 'de préparation' : 'des progrès'}.`}
                    </p>
                    
                    <div className="completion-stats mb-4">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="stat-item">
                                    <h4>{sectionQues?.length || 0}</h4>
                                    <p>{languageUse === 'English' ? 'Sections' : 'Sections'}</p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="stat-item">
                                    <h4>100%</h4>
                                    <p>{languageUse === 'English' ? 'Complete' : 'Terminé'}</p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="stat-item">
                                    <h4>{new Date().toLocaleDateString()}</h4>
                                    <p>{languageUse === 'English' ? 'Completed' : 'Terminé le'}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    {/* Debug button for development/testing */}
                    <div className="mb-3">
                        <Button 
                            onClick={resetAssessmentCompletion}
                            variant="outline-secondary"
                            size="sm"
                            className="me-2"
                        >
                            {languageUse === 'English' ? 'Reset Completion Status' : 'Réinitialiser le statut'}
                        </Button>
                        <Button 
                            onClick={clearAllAssessmentData}
                            variant="outline-danger"
                            size="sm"
                        >
                            {languageUse === 'English' ? 'Clear All Data' : 'Effacer toutes les données'}
                        </Button>
                    </div>
                    
                    <div className="completion-actions">
                        <Button 
                            variant="outline-primary" 
                            className="me-3"
                            onClick={() => {
                                // Show all sections for review
                                setCurrentSection(0);
                                setIsAssessmentComplete(false); // Temporarily show questions for review
                            }}
                        >
                            <i className="bi bi-eye me-2"></i>
                            {languageUse === 'English' ? 'Review Answers' : 'Réviser les Réponses'}
                        </Button>
                        
                        <Button 
                            variant="success"
                            onClick={() => {
                                const encryptedId = CryptoJS.AES.encrypt(decryptedSubId, 'mySecretKey').toString();
                                navigate(`/user/dashboard/${encryptedId}`);
                            }}
                            className="me-2"
                        >
                            <i className="bi bi-graph-up me-2"></i>
                            {languageUse === 'English' ? 'View Results' : 'Voir les Résultats'}
                        </Button>

                        <Button 
                            variant="outline-info"
                            onClick={startNewAssessment}
                            size="sm"
                        >
                            Start Fresh
                        </Button>
                    </div>

                    {/* Assessment Type Specific Next Steps */}
                    <div className="next-steps mt-4">
                        <h4 className="mb-3">
                            {languageUse === 'English' ? 'What would you like to do next?' : 'Que souhaitez-vous faire ensuite ?'}
                        </h4>
                        
                        {isReadinessAssessment ? (
                            // Readiness Assessment completed - offer Progress Assessment
                            <div className="next-steps-options">
                                <Button 
                                    variant="info"
                                    className="me-3 mb-2"
                                    onClick={() => {
                                        // Navigate to start a new Progress Assessment
                                        navigate('/user/history');
                                    }}
                                >
                                    <i className="bi bi-graph-up-arrow me-2"></i>
                                    {languageUse === 'English' ? 'Start Progress Assessment' : 'Commencer l\'évaluation des progrès'}
                                </Button>
                                <Button 
                                    variant="outline-secondary"
                                    className="mb-2"
                                    onClick={() => {
                                        // Navigate to start another Readiness Assessment
                                        navigate('/user/history');
                                    }}
                                >
                                    <i className="bi bi-plus-circle me-2"></i>
                                    {languageUse === 'English' ? 'Start New Readiness Assessment' : 'Commencer une nouvelle évaluation de préparation'}
                                </Button>
                            </div>
                        ) : (
                            // Progress Assessment completed - offer another Progress Assessment
                            <div className="next-steps-options">
                                <Button 
                                    variant="info"
                                    className="me-3 mb-2"
                                    onClick={() => {
                                        // Navigate to start another Progress Assessment
                                        navigate('/user/history');
                                    }}
                                >
                                    <i className="bi bi-graph-up-arrow me-2"></i>
                                    {languageUse === 'English' ? 'Start Another Progress Assessment' : 'Commencer une autre évaluation des progrès'}
                                </Button>
                                <Button 
                                    variant="outline-secondary"
                                    className="mb-2"
                                    onClick={() => {
                                        // Navigate back to Readiness Assessment
                                        navigate('/user/history');
                                    }}
                                >
                                    <i className="bi bi-arrow-left me-2"></i>
                                    {languageUse === 'English' ? 'Return to Readiness Assessment' : 'Retourner à l\'évaluation de préparation'}
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <StyledQuestionPage>

            {!firstIndicator && (
                <div className="assessment-landing">
                    <div className="text-center mb-5">
                        <h1 className="mb-4">
                            {languageUse === 'English' 
                                ? 'Welcome to Your ESG Assessment' 
                                : 'Bienvenue dans votre évaluation ESG'}
                        </h1>
                        <p className="lead mb-4">
                            {languageUse === 'English'
                                ? 'This assessment will help evaluate your company\'s Environmental, Social, and Governance (ESG) practices.'
                                : 'Cette évaluation aidera à évaluer les pratiques environnementales, sociales et de gouvernance (ESG) de votre entreprise.'}
                        </p>
                    </div>

                    <div className="assessment-info-cards mb-5">
                        <Row className="g-4">
                            <Col md={4}>
                                <Card className="assessment-info-card h-100">
                                    <Card.Body>
                                        <div className="d-flex align-items-center mb-3">
                                            <i className="bi bi-clock fs-4 me-2"></i>
                                            <h3 className="h5 mb-0">
                                                {languageUse === 'English' ? 'Time Required' : 'Temps requis'}
                                            </h3>
                                        </div>
                                        <p className="mb-0">
                                            {languageUse === 'English'
                                                ? 'Approximately 30-45 minutes to complete all sections'
                                                : 'Environ 30-45 minutes pour compléter toutes les sections'}
                                        </p>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={4}>
                                <Card className="assessment-info-card h-100">
                                    <Card.Body>
                                        <div className="d-flex align-items-center mb-3">
                                            <i className="bi bi-save fs-4 me-2"></i>
                                            <h3 className="h5 mb-0">
                                                {languageUse === 'English' ? 'Auto-Save Feature' : 'Enregistrement automatique'}
                                            </h3>
                                        </div>
                                        <p className="mb-0">
                                            {languageUse === 'English'
                                                ? 'Your progress is automatically saved as you go'
                                                : 'Votre progression est automatiquement enregistrée'}
                                        </p>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={4}>
                                <Card className="assessment-info-card h-100">
                                    <Card.Body>
                                        <div className="d-flex align-items-center mb-3">
                                            <i className="bi bi-file-earmark-text fs-4 me-2"></i>
                                            <h3 className="h5 mb-0">
                                                {languageUse === 'English' ? 'Supporting Documents' : 'Documents justificatifs'}
                                            </h3>
                                        </div>
                                        <p className="mb-0">
                                            {languageUse === 'English'
                                                ? 'You\'ll be able to upload supporting documents after completing the assessment'
                                                : 'Vous pourrez télécharger des documents justificatifs après avoir terminé l\'évaluation'}
                                        </p>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>

                    <div className="assessment-instructions mb-5">
                        <h2 className="h4 mb-4">
                            {languageUse === 'English' 
                                ? 'How to Complete the Assessment:' 
                                : 'Comment Compléter l\'Évaluation:'}
                        </h2>
                        <Row className="g-4">
                            <Col md={6}>
                                <div className="d-flex align-items-start">
                                    <div className="step-number me-3">1</div>
                                    <div>
                                        <h3 className="h6 mb-2">
                                            {languageUse === 'English'
                                                ? 'Answer All Questions'
                                                : 'Répondre à Toutes les Questions'}
                                        </h3>
                                        <p>
                                            {languageUse === 'English'
                                                ? 'Complete all required questions in each section. Optional questions provide additional context.'
                                                : 'Complétez toutes les questions requises dans chaque section. Les questions facultatives fournissent un contexte supplémentaire.'}
                                        </p>
                                    </div>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="d-flex align-items-start">
                                    <div className="step-number me-3">2</div>
                                    <div>
                                        <h3 className="h6 mb-2">
                                            {languageUse === 'English'
                                                ? 'Save Your Progress'
                                                : 'Enregistrer Votre Progression'}
                                        </h3>
                                        <p>
                                            {languageUse === 'English'
                                                ? 'Use the "Save Section" button to manually save your progress at any time.'
                                                : 'Utilisez le bouton "Enregistrer la section" pour sauvegarder manuellement votre progression à tout moment.'}
                                        </p>
                                    </div>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="d-flex align-items-start">
                                    <div className="step-number me-3">3</div>
                                    <div>
                                        <h3 className="h6 mb-2">
                                            {languageUse === 'English'
                                                ? 'Navigate Between Sections'
                                                : 'Naviguer Entre les Sections'}
                                        </h3>
                                        <p>
                                            {languageUse === 'English'
                                                ? 'Use the navigation menu on the left to move between different assessment areas.'
                                                : 'Utilisez le menu de navigation à gauche pour passer d\'une section à l\'autre.'}
                                        </p>
                                    </div>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="d-flex align-items-start">
                                    <div className="step-number me-3">4</div>
                                    <div>
                                        <h3 className="h6 mb-2">
                                            {languageUse === 'English'
                                                ? 'Upload Supporting Documents'
                                                : 'Télécharger des Documents Justificatifs'}
                                        </h3>
                                        <p>
                                            {languageUse === 'English'
                                                ? 'After completing all sections, you\'ll be prompted to upload relevant documentation.'
                                                : 'Après avoir terminé toutes les sections, vous serez invité à télécharger la documentation pertinente.'}
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            )}

            <div className="assessment-content">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2>{props.currentIndicator}</h2>
                    <div className="d-flex align-items-center gap-3">
                        <Button 
                            color="link"
                            onClick={handleResyncQuestions}
                            disabled={isQuestionLoading}
                            className="p-0"
                            id="resync-tooltip"
                        >
                            {isQuestionLoading ? (
                                <Spinner size="sm" />
                            ) : (
                                <i className="bi bi-arrow-clockwise fs-4"></i>
                            )}
                        </Button>
                        

                    </div>
                </div>
                
                {isQuestionLoading ? (
                    <div className="text-center p-5">
                        <BootstrapSpinner animation="border" variant="success" />
                    </div>
                ) : isAssessmentComplete ? (
                    <CompletionSummary />
                ) : (
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Accordion activeKey={activeKey}>
                            {sectionQues?.map((section, index) => (
                                <Card key={index} className="section-card">
                                    <Card.Header className="question-header d-flex align-items-center">
                                        <i className="bi bi-journal-text section-icon"></i>
                                        <span>{languageUse === 'English' ? section?.section?.name : section?.section?.name_French}</span>
                                        {sectionSaveStatus[index] && (
                                            <div className="section-status">
                                                <i className="bi bi-check-circle-fill"></i>
                                                <span className="ms-2">{languageUse === 'English' ? 'Saved' : 'Enregistré'}</span>
                                            </div>
                                        )}
                                    </Card.Header>
                                    <Accordion.Collapse eventKey={index}>
                                        <Card.Body className="question-body">
                                            <SectionAwareness section={section} />
                                            {/* Required Questions */}
                                            {section?.questions?.filter(q => !q?.questionId?.isOptional)?.map((question, qIndex) => {
                                                const missed = !question.answer && (question.answer === undefined || question.answer === null);
                                                return (
                                                    <div key={qIndex} className={`question-item${missed ? ' missed-required' : ''}`} id={`required-question-${index}-${qIndex}`} style={missed ? { border: '2px solid #dc3545', background: '#fff0f0' } : {}}>
                                                        <div className="d-flex align-items-start mb-3">
                                                            <i className="bi bi-asterisk text-danger me-2"></i>
                                                            <span className="me-2">{qIndex + 1}.</span>
                                                            <span>{languageUse === 'English' ? question?.questionId?.question : question?.questionId?.question_French}</span>
                                                        </div>
                                                        <div className="ps-4">
                                                            <div className="form-check mb-2">
                                                                <input
                                                                    type="radio"
                                                                    className="form-check-input"
                                                                    {...register(`sectionReqAnswers.${index}.${qIndex}.answer`)}
                                                                    value={languageUse === 'English' ? 'yes' : 'Oui'}
                                                                />
                                                                <label className="form-check-label">
                                                                    {languageUse === 'English' ? 'Yes' : 'Oui'}
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input
                                                                    type="radio"
                                                                    className="form-check-input"
                                                                    {...register(`sectionReqAnswers.${index}.${qIndex}.answer`)}
                                                                    value={languageUse === 'English' ? 'no' : 'Non'}
                                                                />
                                                                <label className="form-check-label">
                                                                    {languageUse === 'English' ? 'No' : 'Non'}
                                                                </label>
                                                            </div>
                                                            <input
                                                                type="hidden"
                                                                {...register(`sectionReqAnswers.${index}.${qIndex}.id`)}
                                                                value={question?._id}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            })}

                                            {/* Optional Questions */}
                                            {getUniqueQuestions(section?.questions?.filter(q => q?.questionId?.isOptional))?.length > 0 && (
                                                <div className="mt-4">
                                                    <h5 className="mb-3">
                                                        <i className="bi bi-plus-circle section-icon"></i>
                                                        {languageUse === 'English' ? 'Optional Questions' : 'Questions optionnelles'}
                                                    </h5>
                                                    {getUniqueQuestions(section?.questions?.filter(q => q?.questionId?.isOptional)).map((question, qIndex) => (
                                                        <div key={qIndex} className="question-item">
                                                            <div className="d-flex align-items-start mb-3">
                                                                <span className="me-2">{qIndex + 1}.</span>
                                                                <span>{languageUse === 'English' ? question?.questionId?.question : question?.questionId?.question_French}</span>
                                                                <span className="optional-badge">Optional</span>
                                                            </div>
                                                            <div className="ps-4">
                                                                {question?.questionId?.options?.map((option, optIndex) => (
                                                                    <div key={optIndex} className="form-check mb-2">
                                                                        <input
                                                                            type={(props.currentIndicator === 'Demographics' && qIndex !== 4) ? "radio" : "checkbox"}
                                                                            className="form-check-input"
                                                                            {...register(`sectionOptAnswers.${index}.${qIndex}.answer`)}
                                                                            value={languageUse === 'English' ? option.ans : question?.questionId?.options_French[optIndex]?.ans_French}
                                                                        />
                                                                        <label className="form-check-label">
                                                                            {languageUse === 'English' ? option.ans : question?.questionId?.options_French[optIndex]?.ans_French}
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                                <input
                                                                    type="hidden"
                                                                    {...register(`sectionOptAnswers.${index}.${qIndex}.id`)}
                                                                    value={question?._id}
                                                                />
                                                                {watchSecOthers?.[index]?.[qIndex]?.answer &&
                                                                    typeof watchSecOthers[index][qIndex].answer === 'string' &&
                                                                    watchSecOthers[index][qIndex].answer.includes(languageUse === 'English' ? 'Other' : 'Autre') && (
                                                                        <div className="mt-2">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder={languageUse === 'English' ? 'Please specify' : 'Sila nyatakan'}
                                                                                {...register(`sectionOptAnswers.${index}.${qIndex}.otherAnswer`)}
                                                                            />
                                                                        </div>
                                                                    )}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            ))}
                        </Accordion>
                        
                        {/* Navigation Position Indicator */}
                        <div className="navigation-position mt-4 mb-3 p-3 bg-light rounded">
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="position-info">
                                    <i className="bi bi-info-circle me-2 text-info"></i>
                                    <span className="text-muted">
                                        {(() => {
                                            const currentSectionName = sectionQues[currentSection]?.section?.name || sectionQues[currentSection]?.section?.name_French || `Section ${currentSection + 1}`;
                                            return languageUse === 'English' 
                                                ? `${currentSectionName} (${currentSection + 1} of ${sectionQues?.length}) in ${props.currentIndicator}`
                                                : `${currentSectionName} (${currentSection + 1} sur ${sectionQues?.length}) dans ${props.currentIndicator}`;
                                        })()}
                                    </span>
                                </div>
                                <div className="navigation-hint">
                                    {(() => {
                                        const isLastSection = currentSection === sectionQues.length - 1;
                                        
                                        // Check if this topic should have 5 sections but only got 1 from API
                                        // Show "Last section" when at the last available section
                                        if (isLastSection) {
                                            return (
                                                <span className="text-success">
                                                    <i className="bi bi-check-circle me-2"></i>
                                                    {languageUse === 'English' ? 'Last section - Next click moves to next topic' : 'Dernière section - Prochain clic passe au sujet suivant'}
                                                </span>
                                            );
                                        } else {
                                            return (
                                                <span className="text-muted">
                                                    <i className="bi bi-arrow-right me-2"></i>
                                                    {languageUse === 'English' ? 'More sections in this topic' : 'Plus de sections dans ce sujet'}
                                                </span>
                                            );
                                        }
                                    })()}
                                </div>
                            </div>
                        </div>
                        
                        <div className="d-flex justify-content-between mt-4">
                            <Button 
                                variant="outline-secondary"
                                onClick={() => handleSectionNavigation('prev')}
                                disabled={currentSection === 0}
                            >
                                <i className="bi bi-arrow-left me-2"></i>
                                {languageUse === 'English' ? 'Previous Section' : 'Section précédente'}
                            </Button>
                            
                            <Button
                                className="save-section-btn"
                                onClick={() => saveSection(currentSection, watch())}
                                disabled={isSectionSaving}
                            >
                                {isSectionSaving ? (
                                    <>
                                        <BootstrapSpinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                        {languageUse === 'English' ? 'Saving...' : 'Enregistrement...'}
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-save"></i>
                                        {languageUse === 'English' ? 'Save Section' : 'Enregistrer la section'}
                                    </>
                                )}
                            </Button>

                            <Button
                                variant="success"
                                type="button"
                                disabled={isSectionSaving || saveStatus.isSaving || getMissedRequiredQuestions().length > 0}
                                onClick={() => {
                                    const missed = getMissedRequiredQuestions();
                                    if (missed.length > 0) {
                                        // Highlight missed questions and scroll to first
                                        const firstMissed = document.getElementById(`required-question-${currentSection}-${sectionQues[currentSection].questions.findIndex(q => q._id === missed[0]?._id)}`);
                                        if (firstMissed) {
                                            firstMissed.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                        }
                                        toast.error(languageUse === 'English' ? 'Please answer all required questions before proceeding.' : 'Veuillez répondre à toutes les questions requises avant de continuer.');
                                    } else {
                                        handleSectionNavigation('next');
                                    }
                                }}
                            >
                                {isSectionSaving || saveStatus.isSaving ? (
                                    <>
                                        <BootstrapSpinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className="me-2"
                                        />
                                        {languageUse === 'English' ? 'Loading...' : 'Chargement...'}
                                    </>
                                ) : (
                                    <>
                                <i className="bi bi-arrow-right ms-2"></i>
                                {(() => {
                                    const isLastSection = currentSection === sectionQues.length - 1;
                                    
                                    // Check if this topic should have 5 sections but only got 1 from API
                                    // Show "Next Topic" when at the last available section
                                    if (isLastSection) {
                                        return languageUse === 'English' ? 'Next Topic' : 'Sujet suivant';
                                    } else {
                                        return languageUse === 'English' ? 'Next Section' : 'Section suivante';
                                    }
                                })()}
                                    </>
                                )}
                            </Button>
                        </div>
                    </form>
                )}
                <AutoSaveIndicator />
                <SaveStatusIndicator />
                <Toaster position="top-right" />
                <BreakPrompt />
            </div>
        </StyledQuestionPage>
    );
}

export default QuestionPage
